<ng-container *ngIf="notEmpty$ | async; else stubTmp">
  <div class="title">
    {{ 'classrooms.classroom-page.tabs.meetings' | translate }}
  </div>
  <app-filter-content [tabs]="categoryTabs"
                      [activeTab]="selectedTab"
                      (onSelect)="onSelectItem($event)">
  </app-filter-content>

    <div class="list">
      <ng-template [ngIf]="filteredMeetings.length">
        <ng-container *ngFor="let meeting of filteredMeetings; trackBy: trackMeetingByFn">
          <div class="meeting-card-wrap">
            <app-meeting-card [@meeting] [meeting]="meeting" (changed)="onChanged()"></app-meeting-card>
          </div>
        </ng-container>
      </ng-template>
    </div>
</ng-container>

<app-pagination
  [enabled]="loaded$ | async"
  [loading]="loading$ | async"
  [pagination]="pagination$ | async"
  [nothingMoreText]="''"
  baseUrl=""
  (nextPage)="nextPage()"></app-pagination>

<ng-template #stubTmp>
  <app-no-content-stub
    *ngIf="loaded$ | async"
    (click)="isOwner ? onToggleMeetingForm() : null"
    [icon]="'stub-schedule'"
    [text]="stub">
  </app-no-content-stub>
</ng-template>

<ng-template [ngIf]="newClassOpenForm">
  <app-modal *ngIf="deviceService.isDesktop(); else mobileMeetingForm"
             [canClose]="false"
             (closed)="onToggleMeetingForm()">
    <app-modal-body>
      <app-classroom-meeting-form-wrapper (saved)="onMeetingSaved()" [classroom]="classroom"></app-classroom-meeting-form-wrapper>
    </app-modal-body>
  </app-modal>

  <ng-template #mobileMeetingForm>
    <app-mobile-modal (closed)="onToggleMeetingForm()">
      <app-mobile-modal-title>{{ 'lingo2-forms.meetings.form-title' | translate }}</app-mobile-modal-title>
      <app-mobile-modal-body>
        <app-classroom-meeting-form-wrapper [classroom]="classroom" (saved)="onMeetingSaved()"></app-classroom-meeting-form-wrapper>
      </app-mobile-modal-body>
    </app-mobile-modal>
  </ng-template>
</ng-template>
